'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "Who needs a personal website, and what can it include?",
    answer: "Personal websites are great for professionals, freelancers, influencers, and anyone building a personal brand. Your site can include your portfolio, resume, blog, testimonials, contact info, and more — all in one place."
  },
  {
    question: "Can you match the design to my personality or profession?",
    answer: "Absolutely. We design websites that reflect your style, field, and goals — whether you're a designer, writer, consultant, or public figure. Every layout, font, and color is chosen to match your unique identity."
  },
  {
    question: "How long does it take to create a personal website?",
    answer: "Most personal websites take 3–7 days to design and launch, depending on the number of pages and how ready your content is. We also offer express options if you need it done quickly."
  },
  {
    question: "Will my website work well on mobile and be easy to update?",
    answer: "Yes! We create fully responsive websites that look great on phones, tablets, and desktops. We also build them so you can easily update your content without technical skills if needed."
  },
  {
    question: "Can you help with domain, hosting, and SEO too?",
    answer: "Yes, we provide end-to-end support — from choosing a domain and setting up hosting to optimizing your site for search engines and integrating analytics. We make sure everything is taken care of."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
